module.exports = __webpack_public_path__ + "static/media/crvBTC-logo.8ffd61ac.png";